export class AddUnterFragen{
    static readonly type='[UnterFrage] es muss ein Typ User Objekt zur Liste hinzugefügt werden';
    constructor(public payload: any){}
}
